import React, { useEffect, useState } from 'react';
import { Button, MenuItem } from '@material-ui/core';
import { Observer } from 'mobx-react';
import { useHistory, useParams } from 'react-router-dom';
import { useRootStore } from '../../../stores/BridgeProvider';
import Spinner from '../../util/Spinner';
import { FlexDiv, WideBox } from '../../styles/styles';
import VoucherTransactionForm from '../VoucherTransactionForm';

const EditVoucherTransaction = ({
  voucherTransactionId: passedVoucherTranId,
}) => {
  const history = useHistory();
  const params = useParams();
  const transID = params.transID || passedVoucherTranId;
  const { authStore } = useRootStore();
  const [isLoading, setLoading] = useState(true);
  const [voucherTran, setVoucherTran] = useState(null);
  const getVoucherTran = async () => {
    try {
      const { data } = await authStore.request.get(
        `${process.env.REACT_APP_API}/api/voucher-transaction/${transID}`,
      );
      setVoucherTran(data);
    } catch (e) {
      console.error(e);
    }
  };

  const deleteVoucherTran = async () => {
    try {
      await authStore.request.delete(
        `${process.env.REACT_APP_API}/api/voucher-transaction`,
        {
          data: { VoucherTransactionId: voucherTran.VoucherTranId },
        },
      );
      history.push(`/vouchers/${voucherTran.VoucherId}`);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    const initialize = async () => {
      await getVoucherTran();
      setLoading(false);
    };
    initialize();
  }, []);

  const backToDetailPage = () =>
    history.push(`/vouchers/${voucherTran.VoucherId}`);

  if (isLoading) return <Spinner />;
  return (
    <Observer
      render={() => {
        return (
          <FlexDiv>
            <WideBox showoverflow={1} style={{ maxWidth: '500px' }}>
              <VoucherTransactionForm
                voucherTran={voucherTran}
                menuItems={[
                  <MenuItem key={1} onClick={deleteVoucherTran}>
                    Delete Voucher Transaction
                  </MenuItem>,
                ]}
                onSubmit={async values => {
                  const {
                    VoucherTransactionId,
                    VoucherId,
                    CategoryId,
                    AccountId,
                    Price,
                    Quantity,
                    Description,
                  } = values;
                  try {
                    await authStore.request.post(
                      `${process.env.REACT_APP_API}/api/voucher-transaction`,
                      {
                        VoucherTransactionId,
                        VoucherId,
                        CategoryId,
                        AccountId,
                        Price,
                        Quantity,
                        Description,
                      },
                    );
                    backToDetailPage();
                  } catch (e) {
                    console.error(e);
                  }
                }}
                buttons={[
                  <Button
                    key={1}
                    variant="contained"
                    onClick={() => window.history.back()}
                    size="large"
                    color="secondary"
                  >
                    Cancel
                  </Button>,
                ]}
              />
            </WideBox>
          </FlexDiv>
        );
      }}
    />
  );
};

export default EditVoucherTransaction;
